<div class="container-fluid bg-dark text-center py-5 not-found">
  <div class="row h-100">
    <div class="col-12 my-auto">
      <h2 class="display-3 text-white font-weight-bold text-shadow">
        4<span class="text-warning mx-2">0</span>4
      </h2>
      <p class="my-4 text-shadow">Page Not Found</p>
    </div>
  </div>
</div>
